<template>
    <div class="success-screen">
        <div class="success-box">
            <h2>送出成功</h2>
            <img src="@/assets/icon_success.png" alt="Submission Success" class="success-icon" />
            <p>您的委託合作資料已經送出<br />申辦成功時將以電子郵件和電話通知您</p>
        </div>
        <button @click="goToHomePage" class="success-button">回到首頁</button>

    </div>
</template>

<script>
export default {
    name: 'SuccessScreen',
    methods: {
        goToHomePage() {
            this.$router.push('/');
        },
    },
};
</script>

<style scoped>

@import "@/css/apply_success.css";

/* Success screen overlay */
.success-screen {
    position: fixed;
    margin: 0px;
    padding: 0px;
    top: 0px !important;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: rgba(128, 128, 128, 0.8); Semi-transparent background */
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    z-index: 500;
}

/* Success box styling */
.success-box {
    background-color: white;

    margin-top: 40px;
    padding: 40px 44px;
    border-radius: 10px;
    text-align: center;
    box-sizing: border-box;
    /* Responsive width */
    /* width: 90%; */
    max-width: 400px;

    width: 360px;
    height: 318px;
    border-radius: 20px;

}


.success-icon {
    width: 72px;
    height: 72px;
    margin-top: 32px;
    margin-bottom: 32px;
}

.success-box h2 {
    margin: 0px;

    /* background-color: red; */

    /* //styleName: 5xl/bold; */
    font-family: Inter;
    font-size: 40px;
    font-weight: 700;
    line-height: 53.6px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    color: var(--green04);
}

.success-box p {

    /* //styleName: md/regular; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    color: var(--gray15);

    margin: 0px;

}

.success-button {

    border: none;

    text-decoration: underline;
    margin-top: 20px;

    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    color: var(--green03);


}

/* Responsive design */
@media (max-width: 560px) {
    .success-box {
        padding: 24px 8px;

        width: 225px;
        height: 246px;
        border-radius: 20px;



        margin-top: 40px;
    }

    .success-icon {
        width: 56px;
        height: 56px;

        margin-top: 22px;
        margin-bottom: 22px;
    }

    .success-box h2 {
        /* //styleName: 3xl/bold; */
        font-family: Inter;
        font-size: 28px;
        font-weight: 700;
        line-height: 38.08px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }

    .success-box p {
        /* //styleName: sm/regular; */
        font-family: Inter;
        font-size: 14px;
        font-weight: 400;
        line-height: 21.56px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }

    .success-button {
        /* //styleName: sm/bold; */
        font-family: Inter;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-align: center;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

        margin-top: 16px;


    }
}
</style>